import { Paper, Typography } from "@material-ui/core"
import { observer } from "mobx-react"
import * as React from "react"
import { Link } from "react-router-dom"
import { RoutePaths } from "../../../../portal-app/src/routing/RoutePaths"
import { CCUtils } from "../../common/CCUtils"
import { appTheme } from "../StyleUtils"

const clickCityLogo = CCUtils.asset("generic/images/click-city.png")

interface LoginPageProps {
    title: string
    children: React.ReactNode
    squeeze?: boolean
    smallLogo?: boolean
}

@observer
export class LoginPage extends React.Component<LoginPageProps> {
    render() {
        const { title, children, squeeze, smallLogo } = this.props
        return (
            <Paper
                style={{
                    padding: appTheme.spacing(4, squeeze ? 8 : 4),
                    width: 448,
                    display: "flex",
                    justifyContent: "center",
                    position: "relative",
                }}
            >
                <div
                    style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                    }}
                >
                    <Link to={RoutePaths.home}>
                        <img
                            alt={"Click City"}
                            src={clickCityLogo}
                            style={{
                                display: "block",
                                width: smallLogo ? 48 : 104,
                                marginBottom: appTheme.spacing(2),
                            }}
                        />
                    </Link>
                    <Typography
                        style={{
                            marginBottom: appTheme.spacing(4),
                            textAlign: "center",
                        }}
                        variant={"h4"}
                        dangerouslySetInnerHTML={{ __html: title }}
                    />
                    {children}
                </div>
            </Paper>
        )
    }
}
